import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroller'
import NProgress from 'nprogress'

import Grid from '../Grid';
import ScrobbleFilter from '../filter/ScrobbleFilter';

import Train from '../../services/train.js';
import QueryParamsUtils from '../../services/QueryParamsUtils.js';
import StringUtils from '../../services/StringUtils.js';

import '../../../css/SearchBar.css';

class UserScrobbles extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      userId: this.props.match.params.user,
      page: 1,
      scrobbles: [],
      hasMore: undefined,
      query: undefined
    }
  }

  componentDidMount() {
    this.fetchData(this.getCurrentQuery());
  }

  componentWillReceiveProps(newProps) {
    this.props = newProps;
    this.fetchData(this.getCurrentQuery());
  }

  getCurrentQuery(query) {

    let queryParams = new URLSearchParams(this.props.location.search);

    if (!query) {

      let match = queryParams.get('match');

      query = {
        match
      };
    }

    query.page = this.state.page;
    query.userId = this.state.userId;
    query.month = queryParams.get('month');
    query.year = queryParams.get('year');

    return query;
  }

  fetchData({userId, page, match, month, year}) {

    NProgress.start();

    let scrobbles = this.state.scrobbles;

    if (this.state.page === page) {
      page = 1;
      scrobbles = [];
    }

    Train.fetchUserScrobbles({user: userId, page, match, month, year})
    .then((data) => {
      this.setState({
        scrobbles: scrobbles.concat(data.scrobbles),
        hasMore: data.pagination.page*data.pagination.perPage < data.pagination.total,
        total: data.pagination.total,
        query: match,
        page
      });
      NProgress.done();
    });

  }

  loadMore() {
    if (this.state.hasMore) {
      let query = this.getCurrentQuery();
      query.page += 1;
      this.fetchData(query)
    }
  }

  onChange(query) {
    let queryParams = new URLSearchParams(this.props.location.search);
    query.month = queryParams.get('month');
    query.year = queryParams.get('year');

    queryParams = QueryParamsUtils.toQueryParams(query);
    this.props.history.push(queryParams);
  }

 render() {

    let query = this.getCurrentQuery();

    let title = 'Scrobbles';

    if (query.month && query.year) 
      title = `${title} in ${StringUtils.monthName(query.month)}/${query.year}`;

    return (

      <div className="userPage infinite">

        <ScrobbleFilter 
          match={query.match}
          onChange={this.onChange.bind(this)}
        />
        
        <InfiniteScroll
          loadMore={this.loadMore.bind(this)}
          hasMore={this.state.hasMore}
          loader={<h4>Loading...</h4>}
          useWindow={true}
          >
          <Grid title={title} total={this.state.total} playable={true} type="track" elements={this.state.scrobbles} />
        </InfiniteScroll>

      </div>




    ); 

  }
}

export default withRouter(UserScrobbles);



// WEBPACK FOOTER //
// ./src/js/components/user/UserScrobbles.jsx